

export default {
        data: () => ({
        isIntersecting: false,
  }),

    methods: {
        onIntersect(entries, observer) {

        // More information about these options
        // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        //console.log(observer);
        this.isIntersecting = entries[0].isIntersecting;

    },
  },
}
